<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Discussion forum
          </h4>

          <span class="subheading">
            <p>There is an external discussion forum where you can ask questions, get help, share ideas, and engage with other solvers. Use the <v-btn flat color="primary" to="discussion" class="mx-0 my-0">Discussion</v-btn> link in the navigation panel at any time.</p>

          </span>
          <v-divider class="my-3"></v-divider>
          <!-- <div class="title my-4">?</div> -->
          <v-btn color="primary" dark class="mx-0" to="tour3">Next</v-btn>

        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'Tour2',
    data () {
      return {
        // foo: 'bar'
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('Tour2 component mounted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Tour/Tour2.vue